<template>
  <v-dialog
    :value="true"
    persistent
    max-width="600px"
  >
    <v-card>
      <v-card-title class="pa-3">
        <span class="headline">Nova Solicitação</span>
      </v-card-title>
      <v-card-text>
        <span class="subline pa-3">
          Crie um novo Registro de solicitação do cliente
        </span>
        <v-form
          ref="contactAdd"
          v-model="valid"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="contactType"
                  :items="contactTypes"
                  :rules="[$rules.required()]"
                  :item-text="item => item.label"
                  :item-value="item => item.value"
                  label="Tipo de contato"
                  placeholder="Selecione o tipo de contato"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="name"
                  label="Nome"
                  placeholder="Digite o nome"
                  :rules="[$rules.required()]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="email"
                  :rules="[$rules.required(), $rules.email()]"
                  label="E-mail"
                  placeholder="Digite o email"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="phone"
                  v-mask="'(##) #####-####'"
                  label="Telefone"
                  placeholder="Digite o telefone"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-if="isAtendimentoTecnico()"
                  v-model="service"
                  :items="servicesList"
                  :rules="[$rules.required()]"
                  :item-text="item => item.centralParticao + ' ' + item.tipoConta"
                  :item-value="item => item"
                  label="Serviço"
                  placeholder="Selecione o Serviço"
                  @change="agenda"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-if="service && getAgenda"
                  v-model="schedule"
                  :items="getAgenda"
                  :rules="[$rules.required()]"
                  :item-text="item => item.label"
                  :item-value="item => item.value"
                  label="Agenda"
                  placeholder="Selecione um Horário"
                  no-data-text="Sem datas disponiveis, nos contate através do WhatsApp (11) 4020-4411."
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="message"
                  label="Mensagem"
                  placeholder="Digite a mensagem"
                  :rules="[$rules.required()]"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1" />
        <v-btn
          text
          :to="{name: 'ContactsList'}"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          rounded
          large
          :disabled="!valid"
          @click="submitContact({contact: {email, name, phone, service, schedule, message, contactType}, onSuccess})"
        >
          Adicionar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { mask } from 'vue-the-mask';

export default {
  name: 'ContactsAdd',
  directives: { mask },
  data: () => ({
    valid: false,
    name: null,
    email: null,
    phone: '',
    contactType: null,
    service: {},
    schedule: '',
    message: null,
  }),
  computed: mapGetters('views/contactsList', [
    'contactTypes',
    'servicesList',
    'getAgenda',
  ]),
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.loadServices();
    });
  },
  methods: {
    ...mapActions('views/contactsList', [
      'onAddClick',
      'loadServices',
      'loadSchedules',
    ]),
    onSuccess() {
      this.$router.push({ name: 'ContactsList' });
    },
    agenda(service) {
      this.loadSchedules(service.technicianId);
    },
    isAtendimentoTecnico() {
      if (this.contactType !== 2) {
        this.service = '';
        return false;
      }
      return true;
    },
    submitContact({ contact, onSuccess }) {
      this.onAddClick({ contact, onSuccess });
      this.$refs.contactAdd.reset();
    },
  },
};
</script>
